import { useTranslation } from "react-i18next";
import { styled } from "@mui/material";
import { useChatbotOptions } from "stores";
import Button from "components/ButtonCustom/ButtonNew";

const OptionsHelperText = styled("p")({
  margin: "20px 10px 0 30px",
  textAlign: "left",
  color: "grey",
});

const OptionsWrapper = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  margin: "0 10px",
  "& .option": {
    backgroundColor: "#FAE3C7",
    borderColor: "rgb(158,158,158)",
    color: "inherit",
    fontWeight: "inherit",
    maxWidth: "100%",
    margin: "0 0 5px 5px",
    whiteSpace: "normal",
    wordBreak: "break-word",
    textAlign: "left",
    padding: "0.15rem 0.75rem",
  },
});

const ChatbotOptionsUnstyled = ({ onClick, className }) => {
  const { t } = useTranslation();
  const { filteredOptions, shouldShowCropHelper, noMoreQuestions } =
    useChatbotOptions();

  if (noMoreQuestions) {
    return <></>;
  }

  if (shouldShowCropHelper) {
    return <OptionsHelperText>{t("Chatbot.CropMessage")}</OptionsHelperText>;
  }

  if (filteredOptions.length === 0) {
    return <OptionsHelperText>{t("Chatbot.NoOptions")}</OptionsHelperText>;
  }

  return (
    <OptionsWrapper className={className}>
      {filteredOptions?.map((option, index) => (
        <Button
          key={index}
          onClick={() => onClick(option)}
          className="option"
          corners="square"
        >
          {option}
        </Button>
      ))}
    </OptionsWrapper>
  );
};

const ChatbotOptions = styled(ChatbotOptionsUnstyled)({});

export default ChatbotOptions;
